import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@Auth/useAuth";
import { Entity } from "@models/Entity";
import {
  NewProduct,
  UpdateProduct,
  productsClient,
} from "../clients/ProductsClient";
import { productKeys } from "./productKeys";

export function useCreateProduct() {
  const queryClient = useQueryClient();
  const { baseUser } = useAuth();
  const orgId = baseUser?.organization_id;

  return useMutation({
    mutationFn: (input: NewProduct) => productsClient.create(input),
    meta: { entity: Entity.PRODUCTS, action: "create" },
    onSuccess: () => {
      if (orgId) {
        queryClient.invalidateQueries({ queryKey: productKeys.all(orgId) });
      }
    },
  });
}

export function useUpdateProduct() {
  const queryClient = useQueryClient();
  const { baseUser } = useAuth();
  const orgId = baseUser?.organization_id;

  return useMutation({
    mutationFn: (input: UpdateProduct) => productsClient.update(input),
    meta: { entity: Entity.PRODUCTS, action: "update" },
    onSuccess: (updated) => {
      if (!orgId) return;
      queryClient.invalidateQueries({ queryKey: productKeys.all(orgId) });
      queryClient.setQueryData(
        productKeys.detail(orgId, updated.id),
        updated
      );
    },
  });
}

export function useDeleteProduct() {
  const queryClient = useQueryClient();
  const { baseUser } = useAuth();
  const orgId = baseUser?.organization_id;

  return useMutation({
    mutationFn: (id: string) => productsClient.remove(id),
    meta: { entity: Entity.PRODUCTS, action: "delete" },
    onSuccess: () => {
      if (orgId) {
        queryClient.invalidateQueries({ queryKey: productKeys.all(orgId) });
      }
    },
  });
}
